module.exports = __webpack_public_path__ + "img/t-27809-016.6814f5b5.jpg";